import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { validateShippingAddress } from '../../util/api';
import { denormalisedResponseEntities } from '../../util/data';
import { storableError } from '../../util/errors';
import { fetchCurrentUser, setCurrentUser } from '../../ducks/user.duck';

export const saveShippingAddressThunk = createAsyncThunk(
  'ShippingAddressPage/saveShippingAddress',
  async (address, { dispatch, extra: sdk, rejectWithValue }) => {
    try {
      const validationResponse = await validateShippingAddress({
        address,
        sellerCountry: address?.country,
      });
      const normalizedAddress = validationResponse?.normalizedAddress || address;
      const validation = validationResponse?.validation || null;
      const response = await sdk.currentUser.updateProfile(
        {
          protectedData: {
            shippingAddress: normalizedAddress,
            ...(validation ? { shippingAddressValidation: validation } : {}),
            sellerCountry: normalizedAddress.country,
          },
        },
        {
          expand: true,
          include: ['profileImage'],
          'fields.image': ['variants.square-small', 'variants.square-small2x'],
        }
      );
      const entities = denormalisedResponseEntities(response);
      const currentUser = entities[0];
      dispatch(setCurrentUser(currentUser));
      return { currentUser, normalizedAddress, validation };
    } catch (error) {
      return rejectWithValue(storableError(error));
    }
  }
);

export const saveShippingAddress = address => dispatch =>
  dispatch(saveShippingAddressThunk(address)).unwrap();

const shippingAddressPageSlice = createSlice({
  name: 'ShippingAddressPage',
  initialState: {
    saveShippingAddressInProgress: false,
    saveShippingAddressError: null,
    savedShippingAddressValidation: null,
  },
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(saveShippingAddressThunk.pending, state => {
        state.saveShippingAddressInProgress = true;
        state.saveShippingAddressError = null;
        state.savedShippingAddressValidation = null;
      })
      .addCase(saveShippingAddressThunk.fulfilled, (state, action) => {
        state.saveShippingAddressInProgress = false;
        state.savedShippingAddressValidation = action.payload?.validation || null;
      })
      .addCase(saveShippingAddressThunk.rejected, (state, action) => {
        state.saveShippingAddressInProgress = false;
        state.saveShippingAddressError = action.payload;
        state.savedShippingAddressValidation = null;
      });
  },
});

export default shippingAddressPageSlice.reducer;

export const loadData = () => fetchCurrentUser();
